// extracted by mini-css-extract-plugin
module.exports = {"container":"home_container__2grJ2","left":"home_left__18cye","right":"home_right__1Eaf-"};